import { render, staticRenderFns } from "./SaleReceivableModal.vue?vue&type=template&id=8d1c9f96&scoped=true"
import script from "./SaleReceivableModal.vue?vue&type=script&lang=js"
export * from "./SaleReceivableModal.vue?vue&type=script&lang=js"
import style0 from "./SaleReceivableModal.vue?vue&type=style&index=0&id=8d1c9f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c9f96",
  null
  
)

export default component.exports